export default defineNuxtRouteMiddleware((to, from) => {
  if(process.client) {
    window.addEventListener('storage', storageEventHandler, false);
    function storageEventHandler(e:any){
      if(e.key === 'user-role' && e?.newValue) {
        useRouter().go(0)
      }
    }
  }
})
